import autoBind from 'react-autobind';
import {CommunityLessonDetailContents} from './index';
import {connect} from 'react-redux';
import {getCurrentUserId} from '../../authentication/selectors';
import {handleApiError} from '../../shared/services';
import {loadLessonPlan} from '../actions';
import {Map} from 'immutable';
import muiThemes from '../../../styles/teamologyTheme';
import {Page} from '../../layout/components';
import {withRouter} from 'react-router';
import React, {Component, PropTypes} from 'react';

class CommunityLessonDetailPage extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  componentDidMount() {
    const {lessonId} = this.props.params;
    const {loadLessonPlan, router} = this.props;

    if (lessonId) {
      loadLessonPlan(lessonId)
        .catch(error => handleApiError(error, router, 'An error occurred while attempting to show the Lesson detail.', 'Error'));
    }
  }

  render() {
    const {lessonPlan} = this.props;
    const characterName = lessonPlan.getIn(['character', 'name']);

    const headerStyle = {
      height: 5,
      backgroundColor: characterName ? muiThemes.characterColors[characterName.toLowerCase()] : null,
    };

    const headerClassName = characterName ? null : 'all-character-header';

    return (
      <Page pageClassName="lesson-detail-page">
        <div className={headerClassName} style={headerStyle} />
        <CommunityLessonDetailContents lessonPlan={lessonPlan} />
      </Page>
    );
  }
}

CommunityLessonDetailPage.propTypes = {
  lessonPlan: PropTypes.instanceOf(Map).isRequired,
  loadLessonPlan: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const {showLessonDetail} = state.features.lessonDetail.pages;
  return {
    downloadUrl: showLessonDetail.get('downloadUrl'),
    hoverStates: showLessonDetail.get('hoverStates'),
    lessonPlan: showLessonDetail.get('lessonPlan'),
    loading: showLessonDetail.get('loading'),
    userId: getCurrentUserId(state),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    loadLessonPlan,
  }
)(CommunityLessonDetailPage));



// WEBPACK FOOTER //
// ./app/features/lessonDetail/components/CommunityLessonDetailPage.js